<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col
        span(class=" tw-text-2xl text-secondary tw-font-bold tw-capitalize ") {{ $t('Listings.Common.editListing') }}
  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-4 tw-pb-0 tw-pl-2 tw-overflow-hidden")
    v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0 tw-pb-0 ")
      v-col(class=" tw-h-full  tw-flex tw-flex-col tw-flex-grow  tw-py-0")
        v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && submit($event)")

        v-tabs(vertical class="tw-h-full tw-py-0 tw-my-0")
          v-tab
            span {{ $t('Common.description') }}
          v-tab
            span {{ $t('Listings.Common.location') }}
          v-tab
            span {{ $t('Listings.Common.offering') }}
          v-tab(@click="refresh")
            span {{ $t('Common.photos') }}
          v-tab
            span {{ $t('Listings.Common.amenities') }}
          v-tab
            span {{ $t('Common.contacts') }}

          //Description
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full")
            v-container(fluid class="tw-px-6")
              v-row
                v-col
                  v-row
                    v-col
                      v-text-field(
                        v-model="property.name"
                        :label="$t('Common.name')"
                        :rules="nameRules"
                        color="blue darken-4"
                        required
                        outlined
                        hide-details
                      )
                  v-row
                    v-col
                      v-textarea(
                        v-model="property.description"
                        :label="$t('Common.description')"
                        :rules="descriptionRules"
                        color="blue darken-4"
                        required
                        rows="7"
                        height="330"
                        outlined
                        hide-details
                      )

                v-col
                  v-row
                    v-col
                      v-select(
                        v-model="property.type"
                        :label="$t('Listings.Common.propertyType')"
                        :items="listingTypes"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )
                    v-col
                      v-text-field(
                        v-model="property.year_built"
                        :label="$t('Listings.Common.yearBuilt')"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )

                  v-row
                    v-col
                      v-text-field(
                        v-model="property.construction_size"
                        :label="$t('Listings.Common.constructionSize')"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )
                    v-col
                      v-text-field(v-model="property.plot_size" label="Lot size " outlined hide-details)

                  v-row(justify="space-around")
                    v-col
                      v-select(
                        v-model="property.bedrooms"
                        :label="$t('Listings.Common.bedrooms')"
                        :items="quantity"
                        item-text="label"
                        item-value="value"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )

                    v-col
                      v-select(
                        v-model="property.bathrooms"
                        :label="$t('Listings.Common.bathrooms')"
                        :items="quantity"
                        item-text="label"
                        item-value="value"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )
                  v-row(justify="space-around")
                    v-col
                      v-select(
                        v-model="property.parking_spaces"
                        :label="$t('Listings.Common.parkingSpaces')"
                        :items="quantity"
                        item-text="label"
                        item-value="value"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )

                    v-col
                      v-select(
                        v-model="property.floors"
                        :label="$t('Listings.Common.floors')"
                        :items="quantity"
                        item-text="label"
                        item-value="value"
                        outlined
                        hide-details
                        class="tw-capitalize"
                      )

          //Location            
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full")
            v-container(fluid class="tw-px-6")
              v-row
                v-col(cols="7")
                  v-row
                    v-col(class="tw-pt-0")
                      gmap-autocomplete(v-model="address" class="IntroInput" selectFirstOnEnter @place_changed="setAddress")
                        template(v-slot:input="slotProps")
                          v-text-field(
                            v-model="address"
                            :placeholder="$t('Listings.Common.addressPlaceholder')"
                            ref="input"
                            hide-details
                            v-on:listeners="slotProps.listeners"
                            color="primary"
                          )
                  v-row
                    v-col(cols="9")
                      v-text-field(
                        v-model="property.address_street"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.street')"
                      )
                    v-col(cols="3")
                      v-text-field(
                        v-model="property.address_street_number"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.number')"
                      )
                  v-row(v-if="property.address_extended_address" class="tw-py-0 tw-my-0")
                    v-col
                      v-text-field(
                        v-model="property.address_extended_address"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.extendedAddress')"
                      )
                  v-row
                    v-col
                      v-text-field(
                        v-model="property.addresss_block"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.block')"
                      )
                    v-col
                      v-text-field(
                        v-model="property.address_floor"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.floor')"
                      )
                    v-col
                      v-text-field(
                        v-model="property.address_door"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.door')"
                      )

                  v-row
                    v-col
                      v-text-field(
                        v-model="property.address_city"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.city')"
                      )

                    v-col
                      v-text-field(
                        v-model="property.address_state"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.state')"
                      )

                  v-row
                    v-col
                      v-text-field(
                        v-model="property.address_country"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.country')"
                      )

                    v-col
                      v-text-field(
                        v-model="property.address_zip_code"
                        :disabled="!address"
                        outlined
                        hide-details
                        :label="$t('Common.zipCode')"
                      ) 
                v-col(cols="5")
                  kubiqa-misc-map(:key="key" mapHeight="360px" :position="position")

          //Offering
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full ")
            div(class="  tw-h-full  ")
              v-row(class="tw-h-full")
                v-col(cols="12" class="tw-h-full")
                  v-row(justify="center" align="stretch" class="tw-h-full ")
                    v-col(class="tw-border tw-border-gray-lighten-2 tw-rounded-md tw-mb-10 tw-m-4 tw-overflow-hidden tw-py-0")
                      v-row(class="tw-bg-gray-lighten-4")
                        v-col(class="tw-py-2 tw-pb-4")
                          v-row(align="center")
                            v-col(cols="auto")
                              v-checkbox(
                                v-model="property.sale_enabled"
                                hide-details
                                color="indigo accent-1"
                                :ripple="false"
                                outlined
                                class="tw-font-bold tw-text-3xl "
                              )
                            v-col(class="tw--ml-6")
                              div(class="tw-pt-5")
                                span(class="tw-font-bold tw-text-xl tw-capitalize") {{ $t('Listings.Common.forSale') }}

                      v-row(class="tw-pt-4 tw-px-8")
                        v-col
                          v-text-field(
                            :disabled="!property.sale_enabled"
                            v-model="property.sale_price"
                            outlined
                            :label="$t('Listings.Common.price')"
                            class="tw-capitalize"
                          )

                        v-col
                          v-select(
                            :disabled="!property.sale_enabled"
                            v-model="property.sale_currency"
                            :items="currencies"
                            outlined
                            :menu-props="menuProps"
                            :label="$t('Listings.Common.currency')"
                            class="tw-capitalize"
                          )

                    v-col(class="tw-border tw-border-gray-lighten-2 tw-rounded-md tw-mb-10 tw-m-4 tw-overflow-hidden tw-py-0")
                      v-row(class="tw-bg-gray-lighten-4")
                        v-col(class="tw-py-2 tw-pb-4")
                          v-row(align="center")
                            v-col(cols="auto")
                              v-checkbox(
                                v-model="property.rent_enabled"
                                hide-details
                                outlined
                                color="indigo accent-1"
                                :ripple="false"
                                class="tw-font-bold tw-text-3xl "
                              )
                            v-col(class="tw--ml-6")
                              div(class="tw-pt-5")
                                span(class="tw-font-bold tw-text-xl") {{ $t('Listings.Common.forRent') }}

                      v-row(class="tw-pt-4 tw-px-8")
                        v-col
                          v-text-field(
                            :disabled="!property.rent_enabled"
                            v-model="property.rent_price"
                            :label="$t('Listings.Common.price')"
                            :suffix="'/' + $t('Listings.Common.month')"
                            outlined
                            class="tw-capitalize"
                          )

                        v-col
                          v-select(
                            :disabled="!property.rent_enabled"
                            v-model="property.rent_currency"
                            :items="currencies"
                            :menu-props="menuProps"
                            :label="$t('Listings.Common.currency')"
                            outlined
                            class="tw-capitalize"
                          )

          //Photos
          v-tab-item(
            transition="fade-transition"
            reverse-transition="fade-transition"
            class="tw-h-full tw-max-h-full overflow-hidden  tw-my-0 tw-py-0"
          )
            v-container(fluid class="tw-px-1 tw-h-full tw-max-h-full overflow-hidden tw-my-0 tw-py-0 ")
              v-row(class="tw-h-full tw-max-h-full overflow-hidden tw-my-0")
                v-col(cols="12" class=" tw-h-full tw-max-h-full overflow-hidden tw-py-0")
                  kubiqa-gallery-new(:key="key" class="tw-h-full tw-max-h-full overflow-hidden tw-max-w-full tw-w-full")

          //Amenities
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full")
            v-container(fluid class="tw-h-full")
              v-row(class="tw-h-full")
                v-col(class="tw-h-full")
                  v-row(no-gutters)
                    v-col
                      span(class="tw-text-xl tw-font-medium") {{ $t('Listings.Common.amenitiesTitle') }}
                  v-row(no-gutters class="fill-height tw-pt-4")
                    v-col(
                      v-for="amenities in chunkedAmenityList"
                      :key="amenities.key"
                      class="  fill-height tw-max-h-full tw-overflow-y-scroll"
                    )
                      div(class="tw-flex " v-for="amenity in amenities" :key="amenity.id")
                        v-checkbox(
                          v-model="property.amenities"
                          :label="amenity.name"
                          :value="amenity.id"
                          :ripple="false"
                          color="indigo accent-1"
                          hide-details
                        )

          //Contacts
          v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full")
            v-container(fluid class="tw-h-full")
              v-row(no-gutters class="tw-h-full tw-pb-2")
                v-col(class="tw-h-full")
                  v-row(no-gutters class="tw-h-full ")
                    v-col(class="tw-h-full")
                      kubiqa-contacts-relate-main(entityType="properties")

  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(@click="cancel" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
        v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      loading: false,
      address: '',
      key: 1,
      name: '',
      property: {},
      parking_spaces: '',
      amenityList: {},
      menuProps: {
        maxHeight: '120px',
        overflowyY: true,
      },
      listingTypes: ['House', 'Appartment', 'Office Space', 'Plot'],
      quantity: [
        { value: 1, label: '1' },
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5+' },
      ],
      nameRules: [(v) => !!v || 'Please enter a title for this listing'],
      currencies: ['USD', 'MXN', 'CAD', 'EUR'],
      descriptionRules: [(v) => !!v || 'Please enter a title for this listing'],
    };
  },
  computed: {
    // property(){
    //     return this.$store.getters['properties/property']
    // },
    position() {
      let position = {};
      let property = this.$store.getters['properties/property'];
      position.lat = property.address_latitude;
      position.lng = property.address_longitude;
      return position;
    },
    images() {
      return this.$store.getters['galleries/images'];
    },
    contacts() {
      return this.$store.getters['properties/contacts/list'];
    },
    chunkedAmenityList() {
      let chunkSize = Math.round(this.amenityList.length / 2);
      return this.lodash.chunk(this.amenityList, chunkSize);
    },
  },
  mounted() {
    this.property = JSON.parse(JSON.stringify(this.$store.getters['properties/property']));
    this.$store
      .dispatch('properties/amenityList')
      .then((response) => {
        this.amenityList = response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    setAddress(address) {
      (this.property.address_street = ''),
        (this.property.address_street_number = ''),
        (this.property.address_extended_address = ''),
        (this.property.address_city = ''),
        (this.property.address_state = ''),
        (this.property.address_country = ''),
        (this.property.address_zip_code = ''),
        (this.address = address.formatted_address);
      this.key += this.key;
      this.position.lat = address.geometry.location.lat();
      this.position.lng = address.geometry.location.lng();
      this.property.address_latitude = address.geometry.location.lat();
      this.property.address_longitude = address.geometry.location.lng();
      for (let i = 0; i < address.address_components.length; i++) {
        const componentType = address.address_components[i].types[0];
        switch (componentType) {
          case 'street_number':
            this.property.address_street_number = address.address_components[i].long_name;
            break;

          case 'route':
            this.property.address_street = address.address_components[i].long_name;
            break;

          case 'sublocality_level_1':
            this.property.address_extended_address = address.address_components[i].long_name;
            break;

          case 'locality':
            this.property.address_city = address.address_components[i].long_name;
            break;

          case 'administrative_area_level_1':
            this.property.address_state = address.address_components[i].long_name;
            break;

          case 'country':
            this.property.address_country = address.address_components[i].long_name;
            break;

          case 'postal_code':
            this.property.address_zip_code = address.address_components[i].long_name;
            break;
        }
      }
    },
    refresh() {
      this.key += this.key;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        delete this.property.gallery;
        this.$store
          .dispatch('properties/updateProperty', this.property)
          .then((response) => {
            this.$store.dispatch('properties/viewProperty', this.property.id);
            this.$store.getters['properties/property'];
            this.$emit('close');
            this.loading = false;
          })

          .catch((error) => {
            this.error = true;
            console.log(this.$store.state.error);
            this.error_message = this.$store.state.error;
          });
      }
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="css">
.v-stepper__wrapper {
  height: 100%;
}

.v-tabs-items {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
